module.exports = __webpack_public_path__ + "img/skull_process.96b34964.png";